import { rolesInfo } from "../utility";

export const getRoleDashboardPath = (role, roleObj) => {
  let patientType = "inPatients";
  let status = "current";

  if (!roleObj?.ip_available && roleObj?.op_available) {
    patientType = "outPatients";
    status = "today";
  }

  const appendParams =
    role === "Nurse" ||
    role === "Organization_Admin" ||
    role === "Facility_Admin" ||
    role === "Organization_Owner" ||
    role === "Receptionist" ||
    roleObj == null
      ? ""
      : `?patient-type=${patientType}&status=${status}`;

  return `${rolesInfo[role]?.href || "/dashboard/home"}${appendParams}`;
};

export const redirectToDashboard = (domain, role, roleObj) => {
  const baseUrl = process.env.REACT_APP_PUBLIC_SUBDOMIAN_BASE_URL;
  const finalPath = getRoleDashboardPath(role, roleObj);

  if (process.env.REACT_APP_PUBLIC_ENV === "STAGING") {
    window.location.href = `${baseUrl}${finalPath}`;
  } else {
    window.location.href = `https://${domain}.${process.env.REACT_APP_PUBLIC_DOMAIN}${finalPath}`;
  }
};

export const capitalizeFirstLetter = (word) => {
  if (typeof word !== "string" || word.length === 0) {
    return word; // Return the original word if it's not a string or is empty
  }
  return word.charAt(0).toUpperCase() + word.slice(1);
};
